import { useEffect, useState } from "react"
import bgImage from "../Assets/2151065010.jpg"
import leaseBurden from "../Assets/lease burden.png"
import pic1 from "../Assets/pic1.png"
import compliance from "../Assets/compliance.png"
import ROU from "../Assets/ROU.png"
import modify from "../Assets/modify.png"
import graph1 from "../Assets/graph1.png"
import graph2 from "../Assets/graph2.png"
import graph3 from "../Assets/graph3.png"
import graph4 from "../Assets/graph4.png"
import graph5 from "../Assets/graph5.png"
import img from "../Assets/11235935_11116-Photoroom.png-Photoroom.png"
import Loading from "./Loading";
import { useNavigate } from "react-router-dom";
import { useUser } from "../Context"


export default function LandingPage() {
    const { user } = useUser();
    const navigate = useNavigate();
    const [loadingPageData, setLoadingPageData] = useState([
        {
            heading: "About LeaseSync",
            tagline: "LeaseSync, your ultimate solution for comprehensive lease accounting and management. Fully compliant with Ind AS 116, IFRS 16, and global lease standards, LeaseSync automates and streamlines both initial and ongoing lease accounting tasks. Effortlessly handle large volumes of leasing contracts, ensuring compliance with all reporting and disclosure requirements. Simplify your lease management with LeaseSync, your trusted partner in mastering the complexities of modern lease standards.",
            img: img,
            graph: graph5
        },
        {
            heading: "IFRS 16 and IND AS116 compliance",
            tagline: "keep pace with modern lease compliances through LeaseSync, ensuring you stay updated with the latest standards.",
            img: compliance,
            graph: graph2
        },
        {
            heading: "Unlock the power of Seamless Leasing",
            tagline: "experience effortless lease compliance, asset optimization and financial closure – all in one platform.",
            img: pic1,
            graph: graph1
        },
        {
            heading: "Say Goodbye to Lease Data Worries",
            tagline: "streamline your operations and eliminate the burden of managing extensive lease data.",
            img: leaseBurden,
            graph: graph3
        },
        {
            heading: "Easy lease termination and modification",
            tagline: "adjust your lease agreements with our streamlined solutions without any hassle or complications.",
            img: modify,
            graph: graph4
        },
        {
            heading: "Right-of-Use asset adjustments",
            tagline: "easily adjust Right-of-Use assets, and create amortization schedules within seconds.",
            img: ROU,
            graph: graph5
        },
        // {
        //     heading: "Amortization schedules",
        //     tagline: "adjust your lease agreements with our streamlined solutions without any hassle or complications.",
        //     img: modify,
        //     graph:graph4
        // },
    ])


    return (
        <>
            <section className="w-screen p-12 flex flex-col gap-12">
                {loadingPageData.map((item, index) => (
                    index % 2 === 0 ?
                        <div className="w-full flex gap-6 px-6" key={index}>
                            <img className={`w-1/2 bg-no-repeat bg-center bg-cover p-20 object-contain ${index === 0 && "h-[82vh]"} ${index === 5 && "p-28"}`} src={item.img} alt="pic1" style={{ backgroundImage: `url(${item.graph})` }} />
                            <div className="w-1/2 flex flex-col justify-center gap-6">
                                <h1 className="text-[3.4rem] pb-2 antialiased font-semibold leading-none text-transparent bg-gradient-to-t from-sky-500 to-indigo-500 bg-clip-text">
                                    {item.heading}
                                </h1>
                                <p className="text-xl font-light text-gray-600" >{item.tagline}</p>
                            </div>
                        </div> :
                        <div className="w-full flex gap-6 px-6" key={index}>
                            <div className="w-1/2 flex flex-col justify-center gap-6 p-6">
                                <h1 className="text-[3.4rem] pb-2 antialiased font-semibold leading-none text-transparent bg-gradient-to-t from-sky-500 to-indigo-500 bg-clip-text">
                                    {item.heading}
                                </h1>
                                <p className="text-xl font-light text-gray-600" >{item.tagline}</p>
                            </div>
                            <img className={`w-1/2 bg-no-repeat bg-center bg-cover p-20  pt-0 ${index === 4 && "p-24"}`} src={item.img} alt="pic1" style={{ backgroundImage: `url(${item.graph})` }} />
                        </div>
                ))}
            </section>
        </>
    )
}